var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 1H4.11c-1.89 0-2.36.5-2.36 2.52v5.63c0 1.33.73 1.64 1.62.7v-.01a.88.88 0 0 1 1.39.07l.5.68c.41.54 1.07.54 1.47 0l.5-.68a.88.88 0 0 1 1.4-.07c.89.95 1.61.63 1.61-.7V3.52C10.25 1.5 9.78 1 7.9 1Zm-4 5a.5.5 0 0 1-.5-.5c0-.28.23-.5.5-.5s.5.22.5.5a.5.5 0 0 1-.5.5Zm0-2a.5.5 0 0 1-.5-.5c0-.27.23-.5.5-.5s.5.23.5.5a.5.5 0 0 1-.5.5Zm4.22 1.88H5.38a.38.38 0 0 1-.38-.38c0-.2.17-.38.38-.38h2.75a.38.38 0 0 1 0 .75Zm0-2H5.38a.38.38 0 0 1-.38-.38c0-.2.17-.38.38-.38h2.75a.38.38 0 0 1 0 .75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingsmall);
export default __webpack_public_path__ + "static/media/billing.small.733db1d65c6e750a818d6863facdf543.svg";
export { ForwardRef as ReactComponent };